import { Modal } from '@mantine/core'
import React, { ReactElement } from 'react'

import { getInlineTrackingLink } from '../TrackingLink/getInlineTrackingLink'
import { useInlineTrackingStore } from './useInlineTrackingStore'

export const InlineTracking = (): ReactElement => {
  const { isOpen, close, data } = useInlineTrackingStore()

  const url = data
    ? getInlineTrackingLink(
        data.barcode,
        data.trackingHash,
        data.zip,
        i18n.language,
      )
    : null

  if (!url || !data) {
    return <></>
  }

  return (
    <Modal
      opened={isOpen}
      onClose={close}
      title={`${i18n.t('inline_tracking_title', 'Sendungsverfolgung')} ${
        data.barcode
      }`}
      size="75%"
      styles={{
        content: {
          overflow: 'hidden',
        },
      }}
    >
      <div
        style={{
          // border: '1px solid magenta',
          height: 'min(1200px, calc(90vh - 100px))',
          // width: 'calc(100% - 0px)',
          overflow: 'visible',
          display: 'flex',
          position: 'relative',
        }}
      >
        <div
          style={{
            flex: 1,
            zIndex: 1,
            // border: '1px solid cyan',
            // margin: '-0px -20px -10px -30px',
          }}
        >
          <iframe
            src={url}
            title="TNT"
            width="100%"
            height="100%"
            style={{
              border: '3px solid lime',
              // borderRadius: '4px',
              borderWidth: '0px',
              overflowX: 'hidden',
              backgroundColor: 'white',
            }}
          />
        </div>
      </div>
    </Modal>
  )
}
